import request from '@/utils/request'

// 获取订单详情
export function getOrderInfo(data) {
    return request({
        url: '/api/common/v1/open/yjj/getOrderInfo',
        method: 'post',
        data
    })
}

// 获取订单详情
export function getZfbPayLink(data) {
    return request({
        url: '/api/common/v1/open/yjj/getZfbPayLink',
        method: 'post',
        data
    })
}


// 查询yjj定制-订单列表
export function listOrder(data) {
    return request({
        url: '/api/common/v1/open/yjj/getOrderInfoList',
        method: 'post',
        data: data,
        isToken:'false'
    })
}
// 微信支付
export function getWxPayLink(data) {
    return request({
        url: '/api/common/v1/open/yjj/getVXPayQrCode',
        method: 'post',
        data
    })
}
// 获取微信支付结果
export function getVXPayResult(data) {
    return request({
        url: '/api/common/v1/open/yjj/getVXPayResult',
        method: 'post',
        data
    })
}
